module.exports = __webpack_public_path__ + "img/logo_u1992-13.98779184.svg";